import { createTheme } from "@mui/material/styles";

const colors = {
    primary: "#2563eb",
    primaryDark: "#1d4ed8",
    primaryLight: "#e0edff",

    textPrimary: "#0f172a",
    textSecondary: "#64748b",

    background: "#f8fafc",
    paper: "#ffffff",

    border: "#e2e8f0",

    success: "#16a34a",
    warning: "#f59e0b",
    error: "#dc2626",
    info: "#0284c7",
};

const theme = createTheme({
    palette: {
        mode: "light",

        primary: {
            main: colors.primary,
            light: colors.primaryLight,
            dark: colors.primaryDark,
            contrastText: "#fff",
        },

        secondary: {
            main: colors.textSecondary,
        },

        background: {
            default: colors.background,
            paper: colors.paper,
        },

        text: {
            primary: colors.textPrimary,
            secondary: colors.textSecondary,
        },

        divider: colors.border,

        success: { main: colors.success },
        warning: { main: colors.warning },
        error: { main: colors.error },
        info: { main: colors.info },
    },

    shape: {
        borderRadius: 12,
    },

    spacing: 8,

    typography: {
        fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,

        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },

        body1: { fontSize: "0.95rem" },

        button: {
            textTransform: "none",
            fontWeight: 500,
        },
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    padding: "8px 16px",
                    height: 40,
                    whiteSpace: "nowrap",
                },
            },
        },

        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                size: "small",
            },
        },

        MuiSelect: {
            defaultProps: {
                size: "small",
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    borderRadius: 10,
                    ...(ownerState?.multiline
                        ? {
                            height: "auto",
                            alignItems: "flex-start",
                        }
                        : {
                            height: 40,
                        }),
                }),
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    margin: 12,
                    maxWidth: "calc(100% - 24px)",
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: "18px 22px",
                    fontWeight: 800,
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: "18px 22px",
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: "14px 22px",
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 14,
                },
            },
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                },
            },
        },

        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 600,
                },
            },
        },

        MuiTableRow: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        backgroundColor: "#f1f5f9",
                    },
                },
            },
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                },
            },
        },
    },
});

export default theme;
